<template>
    <div>
        <main-layout-content :breadcrumbs="pageBreadcrumbs">
            <template #right-side>
                <common-button
                    v-if="!$auth.isSubdomainActive()"
                    type="primary"
                    size="tiny-micro"
                    :label="$t('pages.user.user_profile.breadcrumbs.preview')"
                    @click="profilePreview"
                ></common-button>
            </template>

            <template #content>
                <common-tabs ref="tabs" :tabs="tabs" :activeTab="tabs[0].name" @tab-change="tabChanged">
                    <template #profile>
                        <div class="my-profile__deactivate" @click="toogleIsDeleteProfileModalOpen">
                            {{ $t('pages.user.user_profile.delete_profile_button') }}
                        </div>
                        <common-content-wrapper width="medium">
                            <common-content-spacer :isCenter="true" height="medium">
                                <common-content-spacer :isCenter="true" height="tiny">
                                    <common-user-avatar
                                        :user="user"
                                        :showOrginalImage="true"
                                        size="huge"
                                        :withBorder="true"
                                        :hoverText="$t('common.microcopy.select')"
                                        @avatar-click="openUploadPhotoModal"
                                    ></common-user-avatar>
                                </common-content-spacer>
                                <update-profile-form
                                    :userLocations="userLocations"
                                    @open-location-tab="$refs.tabs.tabClicked('locations')"
                                    @open-personal-details-tab="$refs.tabs.tabClicked('personalDetails')"
                                ></update-profile-form>
                            </common-content-spacer>
                        </common-content-wrapper>
                    </template>

                    <template #personalDetails>
                        <common-content-wrapper width="medium">
                            <common-content-spacer :isCenter="true" height="medium">
                                <update-personal-details
                                    :userLocations="userLocations"
                                    @open-location-tab="$refs.tabs.tabClicked('locations')"
                                    @open-personal-details-tab="$refs.tabs.tabClicked('personalDetails')"
                                ></update-personal-details>
                            </common-content-spacer>
                        </common-content-wrapper>
                    </template>

                    <template #locations>
                        <update-locations-component
                            ref="updateLocationsComponent"
                            :isSubmittingForm="isProcessingLocationForm"
                            :locations="userLocations"
                            @add-location="formSubmit"
                            @edit-location="editFormSubmit"
                            @location-deleted="locationDeleted"
                            @open-profile-tab="$refs.tabs.tabClicked('profile')"
                        ></update-locations-component>
                    </template>
                    <template #services>
                        <common-content-spacer height="medium">
                            <common-buttons align="right">
                                <common-button
                                    type="primary"
                                    size="tiny-micro"
                                    :isSubmittable="false"
                                    :label="$t('layouts.app.top_menu.create_service')"
                                    @click="toogleSelectLocationModal()"
                                ></common-button>
                            </common-buttons>

                            <common-tab-links :tabs="offerTabs" :selectedTab="selectedOfferTab" @tab-click="offerTabClicked">
                                <offer-list-component
                                    :activeTab="selectedOfferTab?.name"
                                    :offers="offers"
                                    @offer-deleted="offerDeleted($event)"
                                    @offer-extended="offerExtended($event)"
                                ></offer-list-component>
                            </common-tab-links>
                        </common-content-spacer>
                    </template>
                    <template #discounts>
                        <offer-discount :offers="offers"></offer-discount>
                    </template>
                    <template #inactivity>
                        <common-content-spacer height="medium">
                            <common-buttons align="right">
                                <common-button
                                    v-if="userAvailability"
                                    size="tiny-micro"
                                    type="primary"
                                    :isSubmittable="false"
                                    :label="$t('pages.company.my_company.buttons.add_inactivity')"
                                    @click="openInactivityModal()"
                                ></common-button>
                            </common-buttons>
                            <inactive-availability-list
                                v-if="inactiveAvailabilities.length"
                                :inactiveAvailabilities="inactiveAvailabilities"
                                @inactivity-removed="getInactiveAvailabilities()"
                            >
                                <common-buttons v-if="inactiveAvailabilities?.length == totalCount">
                                    <common-button
                                        type="primary"
                                        :label="$t('common.microcopy.show_more')"
                                        :isProcessing="isLoading"
                                        @click="loadMore"
                                    ></common-button>
                                </common-buttons>
                            </inactive-availability-list>
                            <common-content-spacer v-else :isCenter="true" height="medium">
                                <p>{{ $t('pages.company.my_company.no_added_inactivity') }}</p>
                            </common-content-spacer>
                        </common-content-spacer>
                    </template>
                    <template #chart>
                        <common-content-spacer height="medium">
                            <chart-filter :isStatisticForUser="true" @chart-filter-change="chartFilterChanged"></chart-filter>
                            <chart :chartData="chartData" :totalSumLabel="totalSumLabel"></chart>
                        </common-content-spacer>
                    </template>
                </common-tabs>
            </template>
        </main-layout-content>
        <upload-photo-modal
            v-if="isUploadPhotoModalOpen"
            :heading="$t('forms.user.profile.buttons.upload_profile_photo')"
            :uploadPhotoApi="uploadProfilePhotoApi"
            :previousPhoto="userOriginalPhoto"
            @photo-uploaded="reloadUserAndCloseModal"
            @close="closeUploadPhotoModal"
        ></upload-photo-modal>
        <add-inactivity-modal
            v-if="isAddInactivityModalOpen"
            :availability="userAvailability"
            @close="closeInactivityModal()"
            @out-if-avilability="outOfAvilabilityEvent($event)"
        ></add-inactivity-modal>
        <out-of-availability-modal
            v-if="isOutOfAvailabilityModalOpen"
            :offers="offersOutOfAvailability"
            @close="closeOutOfAvailabilityModal"
            @accepted="submitInactivityFormData()"
        ></out-of-availability-modal>
        <common-yes-no-modal
            v-if="isYesNoModalOpen"
            height="tiny"
            :showWarningIcon="true"
            :headingText="yesNoHeaderText"
            :noButtonText="$t('common.microcopy.close')"
            :yesButtonText="$t('common.microcopy.go_to_profile')"
            @close="closeYesNoModal"
            @continue="goToPage()"
        ></common-yes-no-modal>
        <select-location-modal
            v-if="isSelectLocationModalOpen"
            :locations="userLocations"
            @close="toogleSelectLocationModal"
            @location-selected="createOffer($event)"
            @open-location-tab="openLocationTab()"
        ></select-location-modal>
        <common-yes-no-modal
            v-if="isDeleteProfileModalOpen"
            :showWarningIcon="true"
            :headingText="$t('pages.user.user_profile.modal.delete_profile')"
            :noButtonText="$t('common.microcopy.false')"
            :yesButtonText="$t('common.microcopy.true')"
            height="tiny"
            @close="toogleIsDeleteProfileModalOpen"
            @continue="deleteUserProfile"
        ></common-yes-no-modal>
    </div>
</template>

<script>
    import OfferAPI from 'api/OfferAPI'
    import UsersAPI from 'api/UsersAPI'
    import MainLayoutContent from 'components/layouts/layout-content/MainLayoutContent'
    import UpdateProfileForm from 'components/forms/user/UpdateProfileForm'
    import UpdatePersonalDetails from 'components/forms/user/UpdatePersonalDetails'
    import UpdateLocationsComponent from 'components/page-elements/locations/UpdateLocationsComponent'
    import OfferListComponent from 'components/page-elements/offer/OfferListComponent'
    import RoutesEnum from 'enums/routes.enum'
    import UploadPhotoModal from 'components/modals/UploadPhotoModal'
    import AddInactivityModal from 'components/modals/company/AddInactivityModal'
    import AvailabilityAPI from 'api/AvailabilityAPI'
    import OutOfAvailabilityModal from 'components/modals/availability/OutOfAvailabilityModal'
    import InactiveAvailabilityList from 'components/page-elements/availability/InactiveAvailabilityList'
    import LocationsAPI from 'api/LocationsAPI'
    import SelectLocationModal from 'components/modals/offer/SelectLocationModal'
    import OfferDiscount from 'components/page-elements/offer/OfferDiscount.vue'
    import Store from '~/store'
    import ChartFilter from 'components/page-elements/user/ChartFilter.vue'
    import Chart from 'components/page-elements/chart/Chart.vue'
    import StatisticOptionsEnum from 'enums/statistic_options.enum'
    import CurrencyEnum from 'enums/currency.enum'
    import LanguageEnum from 'enums/language.enum'
    import PriceMixin from 'mixins/PriceMixin'
    import dayjs from 'dayjs'
    import ReservationStatusFilterEnum from 'enums/reservation_status_filter.enum'

    export default {
        mixins: [PriceMixin],

        components: {
            MainLayoutContent,
            UpdateProfileForm,
            UpdatePersonalDetails,
            UpdateLocationsComponent,
            OfferListComponent,
            UploadPhotoModal,
            AddInactivityModal,
            OutOfAvailabilityModal,
            InactiveAvailabilityList,
            SelectLocationModal,
            OfferDiscount,
            ChartFilter,
            Chart,
        },

        data() {
            return {
                userLocations: this.$auth.getUser()?.locationsForUser,
                isProcessingLocationForm: false,
                offers: [],
                activeOffers: [],
                soonToBeExpired: [],
                recentlyExpired: [],
                selectedOfferTab: undefined,
                isUploadPhotoModalOpen: false,
                userAvailability: [],
                isAddInactivityModalOpen: false,
                offersOutOfAvailability: [],
                isOutOfAvailabilityModalOpen: false,
                dateFrom: null,
                dateTo: null,
                availabilityIds: [],
                inactiveAvailabilities: [],
                limit: 10,
                offset: 0,
                totalCount: 10,
                isYesNoModalOpen: false,
                isSelectLocationModalOpen: false,
                chartQuery: {},
                currentYear: new Date().getFullYear(),
                chartData: [],
                totalSumLabel: undefined,
                statisticOption: StatisticOptionsEnum.OFFER,
                isDeleteProfileModalOpen: false,
            }
        },

        computed: {
            numberOfActiveOffers() {
                return this.activeOffers.length
            },
            user() {
                return this.$auth.getUser()
            },
            userOriginalPhoto() {
                return this.user?.photoMain
            },
            numberOfExpiringOffers() {
                return this.soonToBeExpired.length
            },
            numberOfExpiredOffers() {
                return this.recentlyExpired.length
            },
            tabs() {
                const tablist = [
                    {
                        name: 'profile',
                        displayName: this.$t('pages.company.my_company.tabs.profile'),
                        icon: 'profile',
                        withPadding: true,
                    },
                    {
                        name: 'personalDetails',
                        displayName: this.$t('pages.company.my_company.tabs.personal_details'),
                        icon: 'settings',
                        withPadding: true,
                    },
                ]
                if (this.$auth.isSubdomainActive()) {
                    return tablist
                }
                return [
                    ...tablist,
                    {
                        name: 'locations',
                        displayName: this.$t('pages.company.my_company.tabs.locations'),
                        icon: 'location',
                        withPadding: true,
                        hidden: !this.$auth.getUser().locationsForUser.length && this.$route.query.tab !== 'locations',
                    },
                    {
                        name: 'services',
                        displayName: this.$t('pages.company.my_company.tabs.services'),
                        icon: 'services',
                        withPadding: true,
                        hidden: !this.$auth.getUser().locationsForUser.length,
                    },
                    {
                        name: 'discounts',
                        displayName: this.$t('pages.company.my_company.tabs.discount'),
                        icon: 'discount',
                        withPadding: true,
                        hidden: this.activeOffers.length === 0 && this.soonToBeExpired.length === 0,
                    },
                    {
                        name: 'inactivity',
                        displayName: this.$t('pages.company.my_company.tabs.inactivity'),
                        icon: 'clock',
                        withPadding: true,
                        hidden: this.activeOffers.length === 0 && this.soonToBeExpired.length === 0,
                    },
                    {
                        name: 'chart',
                        displayName: this.$t('pages.company.my_company.tabs.chart'),
                        icon: 'chart',
                        withPadding: true,
                        hidden: !this.$auth.getUser().locationsForUser.length,
                    },
                ]
            },
            offerTabs() {
                return [
                    {
                        name: 'active',
                        displayName: this.$t('pages.user.user_profile.offer_tabs.active', { number: this.numberOfActiveOffers }),
                    },
                    {
                        name: 'renewal',
                        displayName: this.$t('pages.user.user_profile.offer_tabs.renewal', {
                            number: this.numberOfExpiringOffers,
                        }),
                    },
                    {
                        name: 'expired',
                        displayName: this.$t('pages.user.user_profile.offer_tabs.expired', {
                            number: this.numberOfExpiredOffers,
                        }),
                    },
                ]
            },
            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.user.user_profile.breadcrumbs.home'),
                        route: { name: RoutesEnum.INDEX.HOME },
                    },
                    {
                        label: this.$t('pages.user.user_profile.breadcrumbs.manage_account'),
                    },
                ]
            },
            uploadProfilePhotoApi() {
                return UsersAPI.uploadProfilePhoto
            },
            yesNoHeaderText() {
                if (!this.$auth.areFirstAndLastNameCompleted()) {
                    return this.$t('modals.complete_profile_modal.complete_first_and_last_name')
                }
                if (!this.$auth.isMobileCompleted()) {
                    return this.$t('modals.complete_profile_modal.complete_mobile_phone')
                }
                return this.$t('pages.user.user_profile.modal.complete_profile')
            },
            isProfileCompleted() {
                return this.$auth.areFirstAndLastNameCompleted() && this.$auth.isMobileCompleted()
            },
            statusOptions() {
                return Object.values(ReservationStatusFilterEnum).map((status) => ({
                    label: this.$t(`components.reservations.reservation_status.statuses.${status.label}`),
                    status,
                    value: status.value,
                }))
            },
        },

        methods: {
            toogleIsDeleteProfileModalOpen() {
                this.isDeleteProfileModalOpen = !this.isDeleteProfileModalOpen
            },
            formSubmit(location) {
                this.userLocations = [...this.userLocations, location]
                this.isProcessingLocationForm = false
                this.$toast.success(this.$t('common.microcopy.success'))
                this.$refs.updateLocationsComponent.toggleIsCreatingLocation()
                this.$refs.updateLocationsComponent.showAutocomplete = true
                this.$auth.reloadUser()
            },
            editFormSubmit({ address, location, cityId, phone, email, locationId, googleBusiness, locationType }) {
                this.isProcessingLocationForm = true
                //TODO: ADD REPEATER IF MULTIPLE NEEDED
                const emails = [{ email }]
                const telephones = [
                    {
                        telephone: phone,
                    },
                ]
                LocationsAPI.editLocationForUser(locationId, {
                    address,
                    location,
                    cityId,
                    telephones,
                    emails,
                    googleBusiness,
                    locationType,
                })
                    .then(() => {
                        this.$auth.reloadUser().then(() => {
                            this.userLocations = this.$auth.getUser()?.locationsForUser
                        })
                        this.isProcessingLocationForm = false
                        this.$toast.success(this.$t('common.microcopy.success'))
                        this.$refs.updateLocationsComponent.toggleIsCreatingLocation()
                    })
                    .catch(() => {
                        this.$toast.error(this.$t('common.errors.common_error'))
                        this.isProcessingLocationForm = false
                    })
            },
            getOffers() {
                OfferAPI.getUserExpirationList().then((offers) => {
                    this.soonToBeExpired = offers.soonToBeExpired.map((offer) => ({ ...offer, extendable: true }))
                    this.recentlyExpired = offers.recentlyExpired.map((offer) => ({ ...offer, extendable: true }))
                })
                OfferAPI.getUserOffers().then((offers) => {
                    this.activeOffers = offers.map((offer) => {
                        if (this.soonToBeExpired.some((obj) => obj.id === offer.id)) {
                            return { ...offer, extendable: true }
                        }
                        return offer
                    })
                    this.offers = this.activeOffers
                })
                this.selectedOfferTab = undefined
            },
            getUserAvailability() {
                UsersAPI.getUserAvailability().then((UserAvailability) => {
                    this.userAvailability = UserAvailability
                })
            },

            deleteUserProfile() {
                UsersAPI.deleteUser()
                    .then(() => {
                        this.$toast.success(this.$t('common.microcopy.success'))
                        this.$auth.logout()
                    })
                    .catch((error) => {
                        if (error.statusCode === 400) {
                            this.$toast.error(this.$t(`validations.${error.error.message}`))
                            this.toogleIsDeleteProfileModalOpen()
                        } else {
                            this.$toast.error(this.$t('common.errors.common_error'))
                        }
                    })
            },

            getChartRevenueData(query) {
                UsersAPI.getChartRevenueData(query).then((response) => {
                    const yearData = response[0]

                    this.chartData = {
                        labels: yearData.months.map((monthData) => {
                            return this.$t(`common.months.${monthData.month - 1}.short`)
                        }),
                        datasets: [
                            {
                                data: yearData.months.map((monthData) => this.setPrice(monthData.revenue)),
                                backgroundColor: ['#55379d'],
                            },
                        ],
                    }
                    let total = `${this.setPrice(response[0].total)} ${query.currency}`
                    this.totalSumLabel = `${this.$t(`forms.chart.chart_filter.total.revenue`)} ${total}`
                })
            },

            getChartOfferData(query) {
                UsersAPI.getChartOfferData(query).then((response) => {
                    const yearData = response[0]

                    this.chartData = {
                        labels: yearData.months.map((monthData) => {
                            return this.$t(`common.months.${monthData.month - 1}.short`)
                        }),
                        datasets: [
                            {
                                data: yearData.months.map((monthData) => monthData.numberOfCalendarEvents),
                                backgroundColor: ['#55379d'],
                            },
                        ],
                    }

                    this.totalSumLabel = `${this.$t(`forms.chart.chart_filter.total.offer`)} ${response[0].total} `
                })
            },

            deleteOfferById(offerId) {
                this.activeOffers = this.activeOffers.filter((o) => o.id !== offerId)
                this.soonToBeExpired = this.soonToBeExpired.filter((o) => o.id !== offerId)
                this.recentlyExpired = this.recentlyExpired.filter((o) => o.id !== offerId)
            },
            offerDeleted(event) {
                this.deleteOfferById(event.offerId)
                this.loadOffersForTab(this.selectedOfferTab)
                this.$toast.success(this.$t('common.microcopy.success'))
            },
            offerExtended(event) {
                this.deleteOfferById(event.extendedOffer.id)
                this.activeOffers.push(event.extendedOffer)
                this.loadOffersForTab(this.selectedOfferTab)
                this.$toast.success(this.$t('common.microcopy.success'))
            },
            loadOffersForTab(tab) {
                if (tab === undefined || tab.name === this.offerTabs[0].name) {
                    this.offers = this.activeOffers
                } else if (tab.name === this.offerTabs[1].name) {
                    this.offers = this.soonToBeExpired
                } else if (tab.name === this.offerTabs[2].name) {
                    this.offers = this.recentlyExpired
                }
            },
            offerTabClicked(tab) {
                this.loadOffersForTab(tab)
                this.selectedOfferTab = tab
            },
            openUploadPhotoModal() {
                this.isUploadPhotoModalOpen = true
            },
            closeUploadPhotoModal() {
                this.isUploadPhotoModalOpen = false
            },
            openInactivityModal() {
                this.isAddInactivityModalOpen = true
            },
            closeInactivityModal() {
                this.isAddInactivityModalOpen = false
            },
            showOutOfAvailabilityModal() {
                this.isOutOfAvailabilityModalOpen = true
            },

            closeOutOfAvailabilityModal() {
                this.isOutOfAvailabilityModalOpen = false
            },
            outOfAvilabilityEvent(event) {
                Store.dispatch('configuration/setIsLoading', true)

                this.dateFrom = event.dateFrom
                this.dateTo = event.dateTo
                this.availabilityIds = event.availabilityIds

                OfferAPI.getAffectedAvailabilityEvents({
                    availabilityIds: this.availabilityIds,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                }).then((res) => {
                    if (!res.outOfTimeOffers.length) {
                        this.submitInactivityFormData()
                    } else {
                        this.offersOutOfAvailability = res.outOfTimeOffers
                        this.showOutOfAvailabilityModal()
                    }
                    Store.dispatch('configuration/setIsLoading', false)
                })
            },
            submitInactivityFormData() {
                AvailabilityAPI.setupInactivity({
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                    availabilityIds: this.availabilityIds,
                })
                    .then(() => {
                        this.$toast.success(this.$t('common.microcopy.success'))
                        this.getInactiveAvailabilities()
                        this.closeInactivityModal()
                        this.closeOutOfAvailabilityModal()
                        this.$auth.reloadUser()
                    })
                    .catch(() => {})
            },
            getInactiveAvailabilities(append = false) {
                this.isLoading = true

                AvailabilityAPI.getUserAvailabilityInactivity({ take: this.limit, skip: this.offset })
                    .then((res) => {
                        this.loadInactiveAvailabilities(res, append)
                    })
                    .finally(() => (this.isLoading = false))
            },
            loadMore() {
                this.offset += this.limit
                this.getInactiveAvailabilities(true)
            },
            loadInactiveAvailabilities(res, append) {
                this.isLoading = true
                this.totalCount += this.offset
                if (append) {
                    this.inactiveAvailabilities = [...this.inactiveAvailabilities, ...res]
                    return
                }
                this.inactiveAvailabilities = res
            },
            reloadUserAndCloseModal() {
                this.closeUploadPhotoModal()
                this.$auth.reloadUser()
            },
            profilePreview() {
                if (!this.isProfileCompleted) {
                    this.isYesNoModalOpen = true
                } else {
                    this.$router.push({ name: RoutesEnum.USER.PROFILE, params: { id: this.user.id, tab: 'profile' } })
                }
            },
            locationDeleted() {
                this.$auth.reloadUser().then(() => {
                    this.userLocations = this.$auth.getUser().locationsForUser
                })
            },
            closeYesNoModal() {
                this.isYesNoModalOpen = false
            },
            toogleSelectLocationModal() {
                if (!this.isProfileCompleted) {
                    this.isYesNoModalOpen = true
                } else {
                    this.isSelectLocationModalOpen = !this.isSelectLocationModalOpen
                }
            },
            createOffer(location) {
                this.$router.push({ name: RoutesEnum.OFFER.CREATE, query: { location: location.id } })
            },
            openLocationTab() {
                this.$refs.tabs.tabClicked('locations')
                this.toogleSelectLocationModal()
            },
            tabChanged(tab) {
                this.$router.push({ name: RoutesEnum.USER.ME, params: { tabType: tab }, query: { tab } })
            },
            goToPage() {
                if (!this.$auth.areFirstAndLastNameCompleted()) {
                    this.$router.push({ name: RoutesEnum.USER.ME, params: { tabType: 'profile' }, query: { tab: 'profile' } })
                    this.isYesNoModalOpen = false
                } else {
                    this.$router.push({
                        name: RoutesEnum.USER.ME,
                        params: { tabType: 'personalDetails' },
                        query: { tab: 'personalDetails' },
                    })
                    this.isYesNoModalOpen = false
                }
            },
            chartFilterChanged(payload) {
                if (!payload.dateFrom && !payload.dateTo) {
                    payload.dateFrom = dayjs().year(this.currentYear).startOf('year').format('YYYY-MM-DD')
                    payload.dateTo = dayjs().year(this.currentYear).endOf('year').format('YYYY-MM-DD')
                }
                this.statisticOption = payload.statisticOption
                delete payload.statisticOption

                if (this.statisticOption === StatisticOptionsEnum.OFFER) {
                    this.getChartOfferData(payload)
                } else {
                    this.getChartRevenueData(payload)
                }
            },
        },

        watch: {
            $route() {
                if (this.$route.query?.tab?.length) {
                    this.$refs.tabs.tabClicked(this.$route.query?.tab)
                    this.$router.replace({ query: null })
                }
            },

            '$route.params.tabType': {
                handler: function () {
                    if (this.$route.params.tabType) {
                        this.$refs.tabs.tabClicked(this.$route.params.tabType)
                    }
                },
            },
        },

        created() {
            this.getOffers()
            this.getUserAvailability()
            this.getInactiveAvailabilities()
            this.chartQuery.dateFrom = dayjs().year(this.currentYear).startOf('year').format('YYYY-MM-DD')
            this.chartQuery.dateTo = dayjs().year(this.currentYear).endOf('year').format('YYYY-MM-DD')
            this.chartQuery.status = this.statusOptions
                .filter((item) =>
                    [
                        ReservationStatusFilterEnum.DONE.value,
                        ReservationStatusFilterEnum.ACCEPTED.value,
                        ReservationStatusFilterEnum.OPEN.value,
                    ].includes(item.value),
                )
                .map((item) => item.value)
            if (this.$i18n.locale === LanguageEnum.SR) {
                this.currency = CurrencyEnum.RSD.value
            } else if (this.$i18n.locale === LanguageEnum.BIH) {
                this.currency = CurrencyEnum.BAM.value
            } else {
                this.currency = CurrencyEnum.EUR.value
            }
            this.getChartOfferData(this.chartQuery)
        },

        mounted() {
            if (this.$route.params.tabType) {
                this.$refs.tabs.tabClicked(this.$route.params.tabType)
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .my-profile {
        &__deactivate {
            position: absolute;
            bottom: 10px;
            left: 10px;
            font-size: $font-size--form;
            color: $color--accent-11;

            @include breakpoint(tablet-small) {
                bottom: 0px;
                left: 5px;
                font-size: $font-size--secondary;
            }
            &:hover {
                cursor: pointer;
            }
        }
    }
</style>
